import { render } from "./bill-list-staff.vue?vue&type=template&id=8f2f3380&ts=true"
import script from "./bill-list-staff.vue?vue&type=script&lang=ts"
export * from "./bill-list-staff.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_8f6e2ea806ee27baec234857288b09f4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__